<span (mouseenter)="enter()" (mouseleave)="exit()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <ng-content select="[subject]"/>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen">
        <div class="tooltip-content">
            <ng-content select="[tooltip]"/>
        </div>
    </ng-template>
</span>